import { Button } from '@/components/common';
import styles from './LockdownModeWarning.module.css';

interface LockdownModeWarningProps {
  onRetry: () => void;
}

export const LockdownModeWarning = ({ onRetry }: LockdownModeWarningProps) => {
  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Identity verification can&apos;t start</h3>
      <p className={styles.description}>
        Your device appears to have <strong>Lockdown Mode</strong> turned on. It blocks the camera and security features
        we need to verify your identity, so the check can&apos;t run.
      </p>
      <p className={styles.description}>To continue, turn Lockdown Mode off for this site, then try again:</p>
      <ol className={styles.steps}>
        <li>Tap the &quot;aA&quot; menu on the left of the address bar.</li>
        <li>
          Choose <strong>Turn off Lockdown Mode…</strong> for app.relaypay.io.
        </li>
        <li>
          Or open <strong>Settings → Privacy &amp; Security → Lockdown Mode</strong> to turn it off, then reload.
        </li>
      </ol>
      <Button fluid onPress={() => onRetry()}>
        I&apos;ve turned it off — try again
      </Button>
    </div>
  );
};
